<template>
  <div>
    <el-row type="flex" align="middle" justify="space-between">
      <el-col :span="12">
        <div class="page-title">練習詳情</div>
      </el-col>
      <el-col :span="4" style="text-align: right;">
        <el-button type="info" @click="onEditButton">編輯練習</el-button>
      </el-col>
    </el-row>
    <div class="page-box">
      <vue-dividing-line title="基本信息"></vue-dividing-line>
      <el-row class="page-row-list">
        <el-col :span="12"> 練習編號：{{ detail.number }} </el-col>
        <el-col :span="12"> 語言 :{{ detail.lang | language }} </el-col>
      </el-row>
      <el-row class="page-row-list">
        <el-col :span="12"> 描述：{{ detail.desc }} </el-col>
      </el-row>
      <vue-dividing-line title="講解"></vue-dividing-line>
      <el-row type="flex">
        <el-col v-if="detail.guideVideoUrl" :span="12">
          講解影片：
          <videoPlayer :videoUrl="detail.guideVideoUrl"></videoPlayer>
        </el-col>
        <el-col v-else :span="12">
          講解圖片：
          <el-image
            style="width: 100px; height: 100px;"
            :src="detail.guideImageUrl"
          ></el-image>
        </el-col>
      </el-row>
      <vue-dividing-line title="練習題目"></vue-dividing-line>
      <el-row class="page-row-list">
        <el-col :span="12"> 隨機抽取：{{ detail.randomNumber }} </el-col>
        <el-col :span="12"> 及格分數線：{{ detail.passScore }} </el-col>
      </el-row>
      <el-row class="page-row-list">
        <el-col :span="12"> 題目列表： </el-col>
      </el-row>
      <el-table :data="detail.questions" style="width: 100%;">
        <el-table-column prop="number" label="題目編號"> 
          <template slot-scope="{ row }">
            <span class="action-link cursor" @click="onNumber(row.id)">{{ row.number }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="題目類型">
          <template slot-scope="{ row }">
            <span>{{ row.type | questions }}</span>
          </template>
        </el-table-column>
      </el-table>
      <vue-dividing-line title="練習所在課題"></vue-dividing-line>
      <el-table :data="detail.topics">
        <el-table-column prop="number" label="課題編號"> </el-table-column>
        <el-table-column prop="createdAt" label="發佈時間"> 
          <template slot-scope="{ row }">
            <span>{{ row.createdAt | formatDate }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import videoPlayer from './components/videoPlayer'
import { getPractisesDetail } from "@/api/practises";
export default {
  components: {videoPlayer},
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      detail: {},
    };
  },
  created() {
    this.getPractisesDetail();
  },
  methods: {
    onNumber(id){
     let path = `/question/${id}`
     this.resolveRouter(path)
    },
    onEditButton() {
      let path = `/practice/${this.id}/edit`
      this.resolveRouter(path)
    },
    getPractisesDetail() {
      getPractisesDetail(this.id).then((v) => {
        this.detail = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 10px;
  background-color: #fff;
  margin-top: 20px;
}
</style>